export default __webpack_public_path__ + "static/media/Web_05-01.efb5422e.png";